/*
 Stan strony z ofertą / rezerwacjami
 
 Redux (z użyciem redux-compact)
 https://github.com/maciekwawro/redux-compact

 */
import { applyMiddleware, compose, createStore, Store } from 'redux';

import logger from 'redux-logger';

import thunk from 'redux-thunk';

import { definition, create, combine, StateOf } from 'redux-compact';
import { setValueReducer  } from 'redux-compact/plugins';

import { Bramka, Bilet, RaportUtargZaCoSuma, RaportUtargZaCoGrupaAsortymenty, KarnetLogo, Doladowania, KarnetDoladowania, KarnetZjazdy, InfoNew, PortalInfo } from '../api';


import i18n from '../cfg/i18n';
import CONFIG from '../cfg/config';
import { sendFcmErrorLog } from 'common/helpers';

export type Powiadomienie = {
  opis: string;
  typ: string;
}


export type FcmMessage = {
  text: string;
  type: number;
}

export type Navigator = {
  page : number;
  perPage : number;
  filter : string;
  order : string;
 }

export interface IPageState {
  
  lang : string; // język
  theme: string,

  bramki: Bramka[],
  bilety: Bilet[],

  paginacjaPowiadomienia: number[],
  powiadomienia: Powiadomienie[],
  fcmMobileNr: string,
  alertHotelId: string,

  raportData: string,
  raportUtargZaCoSuma: RaportUtargZaCoSuma;
  raportUtargZaCoGrupyAsortymenty: RaportUtargZaCoGrupaAsortymenty[];
  aOperatorId: number,

  regulaminWypozyczenia: boolean,
  regulaminZamowienia: boolean,
  gdzieLink: number,

  karnet: KarnetLogo,
  jestKarnet: boolean,
  karnetKwotowy: Doladowania[],
  karnetCzasowy: Doladowania[],
  karnetOdDo: Doladowania[],

  karnetDoladowania: KarnetDoladowania[],
  karnetZjazdy: KarnetZjazdy[],

  portalInfo: InfoNew,

  fcmLogMessage: FcmMessage[],
  kanalPlatnosci: string,
  tablet: boolean,

  refresh: number,
  openInfo: number,

  timer: number,
  czyTimer: boolean,

  potwierdzAktywny: string,
  lightMode: boolean,
  trybCiemnyIdent: string

};
 
const pageState = definition<IPageState>()
  .setDefault(
    { 
      lang: 'pl',
      theme: "0",   

      bramki: [],
      bilety: [],

      paginacjaPowiadomienia: [0, 1, 10],
      powiadomienia: [],
      fcmMobileNr: "100",
      alertHotelId: "",


      raportData: "6",
      raportUtargZaCoSuma: new RaportUtargZaCoSuma(),
      raportUtargZaCoGrupyAsortymenty: [],
      aOperatorId: 1,

      regulaminWypozyczenia: false,
      regulaminZamowienia: false,
      gdzieLink: 0,

      karnet: new KarnetLogo(),
      jestKarnet: false,
      karnetKwotowy: [],
      karnetCzasowy: [],
      karnetOdDo: [],

      karnetDoladowania: [],
      karnetZjazdy: [],

      portalInfo: new InfoNew(),

      fcmLogMessage: [],
      kanalPlatnosci: "0",
      tablet: false,

      refresh: 0,
      openInfo: 0,

      timer: 0,
      czyTimer: true,

      potwierdzAktywny: "1",
      lightMode: true,
      trybCiemnyIdent: "0"
    })
  .addReducers({
  

    setLang: (pageState: IPageState, lang: string) => {
      i18n.changeLanguage(lang)
      //  alert(pageState.lang+'->'+i18n.language)
      //  alert(JSON.stringify(i18n.languages))
      return ({ ...pageState, lang: lang, langPhone: { flag: lang, prefix: undefined } })
    },
    // setTheme: (pageState: IPageState, theme : string) => 
    //   ({...pageState, theme : theme}),   

    setBramki: (pageState: IPageState, bramki: Bramka[]) =>
      ({ ...pageState, bramki: bramki }),
    setBilety: (pageState: IPageState, bilety: Bilet[]) =>
      ({ ...pageState, bilety: bilety }),

    setPaginacjaPowiadomienia: (pageState: IPageState, tab: number[]) =>
      ({ ...pageState, paginacjaPowiadomienia: tab }),
    setPowiadomienia: (pageState: IPageState, powiadomienie: Powiadomienie) => {
      let tab = pageState.powiadomienia
      if (tab.length > 0 && powiadomienie.opis === tab[0].opis) return ({ ...pageState }) //brak zapisu zduplikowanych
      if (tab.length >= 100) {//maksymalna ilość powiadomień
        tab.pop()
      }
      let powiadomienia = [powiadomienie, ...tab]
      return ({ ...pageState, powiadomienia: powiadomienia })
    },
    setAlertHotelId: (pageState: IPageState, id: string) =>
      ({ ...pageState, alertHotelId: id }),



    setRaportData: (pageState: IPageState, data: string) =>
      ({ ...pageState, raportData: data }),
    setRaportUtargZaCoSuma: (pageState: IPageState, aRaportUtargZaCoSuma: RaportUtargZaCoSuma) =>
      ({ ...pageState, raportUtargZaCoSuma: aRaportUtargZaCoSuma }),
    setRaportUtargZaCoGrupyAsortymenty: (pageState: IPageState, aRaportUtargZaCoGrupyAsortymenty: RaportUtargZaCoGrupaAsortymenty[]) =>
      ({ ...pageState, raportUtargZaCoGrupyAsortymenty: aRaportUtargZaCoGrupyAsortymenty }),

    setRegulaminWypozyczenia: (pageState: IPageState, r: boolean) =>
      ({ ...pageState, regulaminWypozyczenia: r }),
    setRegulaminZamowienia: (pageState: IPageState, r: boolean) =>
      ({ ...pageState, regulaminZamowienia: r }),
    setGdzieLink: (pageState: IPageState, gdzieLink: number) =>
      ({ ...pageState, gdzieLink: gdzieLink }),

    setKarnet: (pageState: IPageState, karnet: KarnetLogo) => {
      let jestKarnet = false;
      if(karnet.ekarta) jestKarnet = true;
      return ({ ...pageState, karnet: karnet, jestKarnet: jestKarnet }) 
    },
    setDoladowania: (pageState: IPageState, doladowania: Doladowania[]) => {
      let karnetKwotowy = doladowania.filter(x => x.jakRozliczac === "3")
      let karnetCzasowy = doladowania.filter(x => x.jakRozliczac === "2")
      let karnetOdDo = doladowania.filter(x => x.jakRozliczac === "6")
      return ({ ...pageState, karnetKwotowy: karnetKwotowy, karnetCzasowy: karnetCzasowy, karnetOdDo: karnetOdDo })
    },
      
    setKarnetDoladowania: (pageState: IPageState, doladowania: KarnetDoladowania[]) =>
      ({ ...pageState, karnetDoladowania: doladowania }), 
    setKarnetZjazdy: (pageState: IPageState, zjazdy: KarnetZjazdy[]) =>
      ({ ...pageState, karnetZjazdy: zjazdy }), 
    setPortalInfo: (pageState: IPageState, info: InfoNew) =>
      ({ ...pageState, portalInfo: info }), 
    setKanalPlatnosci: (pageState: IPageState, k: string) =>
      ({ ...pageState, kanalPlatnosci: k }), 
     setTablet: (pageState: IPageState, t: boolean) =>
      ({ ...pageState, tablet: t,}),  // lightMode: !t
     setRefresh: (pageState: IPageState) =>
      ({ ...pageState, refresh: pageState.refresh + 1 }), 
     setOpenInfo: (pageState: IPageState) =>
      ({ ...pageState, openInfo: pageState.openInfo + 1 }), 
     
    setTimer: (pageState: IPageState, timer: boolean = true, czyTimer: boolean = true) => {
      //clearTimeout(pageState.timer)

      return ({ ...pageState, timer: timer ? pageState.timer + 1 : pageState.timer, czyTimer: czyTimer })

    },

    setIdentyPotwierdzAktywny: (pageState: IPageState, potwierdzAktywny: string) =>
      ({ ...pageState, potwierdzAktywny: potwierdzAktywny,  }),
    setLightMode: (pageState: IPageState, lightMode: boolean) =>
      ({ ...pageState, lightMode: lightMode,  }),
    setTrybCiemnyIdent: (pageState: IPageState, trybCiemnyIdent: string) =>
      ({ ...pageState, trybCiemnyIdent: trybCiemnyIdent,  }),

    // clearTimer: (pageState: IPageState,) => {
    //   clearTimeout(pageState.timer)
    //   return ({ ...pageState, timer: null, timerPlatnosc: false })
    // },

// setTimer: (pageState: IPageState, platnosc: boolean = false) => {
//       clearTimeout(pageState.timer)

//       return ({
//         ...pageState,
//         timer: setTimeout(() => {
//           window.close()
//         }, platnosc ? 900000 : 3000), //30s
//         timerPlatnosc: platnosc ? true: pageState.timerPlatnosc
//       })

//     },

//     clearTimer: (pageState: IPageState,) => {
//       clearTimeout(pageState.timer)
//       return ({ ...pageState, timer: null, timerPlatnosc: false })
//     },



    
   

    addFcmLogMessage: (pageState: IPageState, text: string, type: number) => {
      let log = pageState.fcmLogMessage
      log.push({ text: text, type: type })
      if (log.length >= 5 || type === 2) {
        sendFcmErrorLog(log)
        return ({ ...pageState, fcmLogMessage: [] })
      }
      return ({ ...pageState, fcmLogMessage: log })
    },
  });

/*
const pageStates = list({ of: pageState, key: pageState  => pageState.id}).addReducers({
    add: (pageStates: PageState[], pageState: PageState) => [...pageStates, pageState]
});
*/

const auth = definition<string | undefined>().
  setDefault(window.localStorage.getItem('accessToken') || undefined).
  use(setValueReducer).addActionCreators({
    login: function (accessToken: string) {
      window.localStorage.setItem('accessToken', accessToken);
      return this.setValue(accessToken);
    },
    logout: function () {
      window.localStorage.removeItem('accessToken');
      return this.setValue(undefined)
    }
  });
  

const appState = combine({
  auth,
  pageState
});
  
const { Actions, reduce } = create(appState);
export type AppState = StateOf<typeof appState>;

export const store: Store<AppState> = createStore(  reduce,
  applyMiddleware(thunk, logger),
);

export { Actions };
